/**
 * Published events for when users enter checkout for various products
 */

import type { PackageUpSellAttribution } from "../../upSell/packageUpSellParams";

type PackageEventAttribution = Omit<PackageUpSellAttribution, "flight_trip_id">;

export enum RbcCheckoutEventName {
  viewed_flight_checkout = "viewed_flight_checkout",
  viewed_car_checkout = "viewed_car_checkout",
  viewed_hotel_checkout = "viewed_hotel_checkout",
  viewed_package_checkout = "viewed_package_checkout",
  viewed_activities_checkout = "viewed_activities_checkout",
}

export interface ViewedFlightCheckoutEvent {
  name: RbcCheckoutEventName.viewed_flight_checkout;
  properties: {
    rbc_price_tab?: "fixed" | "flex";
  };
}

export interface ViewedCarCheckoutEvent {
  name: RbcCheckoutEventName.viewed_car_checkout;
  properties: Record<string, never>;
}

export interface ViewedHotelCheckoutEvent {
  name: RbcCheckoutEventName.viewed_hotel_checkout;
  properties: Record<string, never>;
}

export interface ViewedPackageCheckoutEvent {
  name: RbcCheckoutEventName.viewed_package_checkout;
  properties: PackageEventAttribution;
}

export interface ViewedActivitiesCheckoutEvent {
  name: RbcCheckoutEventName.viewed_activities_checkout;
  properties: Record<string, never>;
}

export type ViewedCheckoutEvent =
  | ViewedFlightCheckoutEvent
  | ViewedCarCheckoutEvent
  | ViewedHotelCheckoutEvent
  | ViewedPackageCheckoutEvent
  | ViewedActivitiesCheckoutEvent;
